import Image from 'next/image';
import React, { ReactNode } from 'react';
import Logo from '@/public/logo.svg';
import Container from '../ui/container';
import Typography from '../ui/typography';
const NotFound = ({ title, node }: { title: string; node?: ReactNode }) => {
  return (
    <div className="w-full">
      {node ? (
        <div className="flex w-full flex-col items-center justify-center gap-4">
          {node}
          <Typography component={'h2'} variant={'h4'} weight={'medium'} color={'gray'}>
            {title}
          </Typography>
        </div>
      ) : (
        <div className="relative mx-auto grid h-full w-[80%] place-items-center py-14">
          <Image
            src={Logo}
            fill
            alt="logo"
            className="pointer-events-none object-contain opacity-10"
            priority
          />
          <Typography component={'h2'} variant={'h1'} weight={'bold'} color={'gray'}>
            {title}
          </Typography>
        </div>
      )}
    </div>
  );
};

export default NotFound;
